import styled from "styled-components";
import { Link } from "react-router-dom";

export const NewcomersCardWrapper = styled.div`
  .cover-image-container {
    height: 200px;
    
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
      height: 190px;
    }
    
    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      height: 180px;
    }
    
    @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
      height: 190px;
    }
    
    @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
      height: 200px;
    }
    
    @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
      height: 220px;
    }
  }
  
  .property-price-newcomers {
    font-size: ${20 / 16}rem;
    font-weight: 700;
    color: ${({ theme }) => theme.palette.primary.blue600};
    margin-bottom: 4px;
    
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
      font-size: ${19 / 16}rem;
    }
    
    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      font-size: ${18 / 16}rem;
    }
    
    @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
      font-size: ${19 / 16}rem;
    }
    
    @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
      font-size: ${20 / 16}rem;
    }
    
    @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
      font-size: ${22 / 16}rem;
    }
  }
  
  .property-title-newcomers {
    font-size: ${16 / 16}rem;
    font-weight: 600;
    color: ${({ theme }) => theme.palette.primary.blue900};
    margin-top: 6px;
    line-height: 1.3;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    min-height: calc(1.3em * 2);
    
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
      font-size: ${15 / 16}rem;
    }
    
    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      font-size: ${14 / 16}rem;
    }
    
    @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
      font-size: ${15 / 16}rem;
    }
    
    @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
      font-size: ${16 / 16}rem;
    }
    
    @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
      font-size: ${18 / 16}rem;
    }
  }
  
  .property-address-newcomers {
    font-size: ${13 / 16}rem;
    font-weight: 500;
    color: ${({ theme }) => theme.palette.greyscale.grey700};
    margin-top: 4px;
    opacity: 0.8;
    line-height: 1.4;
    
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
      font-size: ${12 / 16}rem;
    }
    
    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      font-size: ${11 / 16}rem;
    }
    
    @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
      font-size: ${11 / 16}rem;
    }
    
    @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
      font-size: ${13 / 16}rem;
    }
  }
  
  .property-detail-newcomers {
    font-size: ${12 / 16}rem;
    font-weight: 500;
    color: ${({ theme }) => theme.palette.greyscale.grey800};
    
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
      font-size: ${11 / 16}rem;
    }
    
    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      font-size: ${10 / 16}rem;
    }
    
    @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
      font-size: ${10 / 16}rem;
    }
    
    @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
      font-size: ${12 / 16}rem;
    }
  }
  
  .property-detail-icon-newcomers {
    width: ${16 / 16}rem;
    height: ${16 / 16}rem;
    color: ${({ theme }) => theme.palette.secondary.orange500};
    
    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      width: ${14 / 16}rem;
      height: ${14 / 16}rem;
    }
    
    @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
      width: ${16 / 16}rem;
      height: ${16 / 16}rem;
    }
  }
  
  .property-info-container-newcomers {
    padding: 12px 12px 16px;
    
    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      padding: 10px 10px 14px;
    }
    
    @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
      padding: 16px 14px 20px;
    }
  }
  
  .property-details-wrapper-newcomers {
    padding-top: 12px;
    margin-top: 12px;
    border-top: 1px solid hsl(245, 60%, 96%);
    
    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      padding-top: 10px;
      margin-top: 10px;
    }
    
    @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
      padding-top: 14px;
      margin-top: 14px;
      border-top-width: 1.5px;
    }
  }
`;

export const Wrapper = styled.div`
  margin-top: 32px;
  position: relative;
  
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin-top: 48px;
  }
`;

export const TitleSeeMoreWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 16px;
  flex-wrap: wrap;

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin-top: 48px;
  }
`;

export const DescriptionTitle = styled.h2`
  font-size: 1rem;
  font-family: "Inter", sans-serif;
  color: rgb(56, 56, 56);
  font-weight: 600;
  margin-right: auto;
  line-height: 1.2;
  margin-bottom: 4px;
  
  @media (min-width: ${({ theme }) => theme.breakpoints.mobileXs}) {
    font-size: ${18 / 16}rem;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${20 / 16}rem;
    margin-bottom: 0;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    font-size: ${22 / 16}rem;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    font-size: ${24 / 16}rem;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
    font-size: ${26 / 16}rem;
  }
`;

export const SeeMoreLink = styled(Link)`
  font-size: ${14 / 16}rem;
  min-height: 32px;
  padding: 6px 0;
  color: ${({ theme }) => theme.palette.primary.blue500};
  font-family: "Inter", sans-serif;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-weight: 500;
  width: 100%;
  opacity: 0.9;
  position: relative;
  z-index: 2;
  text-decoration: none;
  touch-action: manipulation;

  svg {
    width: ${16 / 16}rem;
    height: ${16 / 16}rem;
    margin-left: 4px;
    opacity: 0.8;
  }
  
  &:hover {
    opacity: 1;
    color: ${({ theme }) => theme.palette.primary.blue600};
  }

  &:focus-visible {
    border-radius: 4px;
    outline: 2px solid ${({ theme }) => theme.palette.primary.blue600};
    outline-offset: 2px;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.mobileXs}) {
    width: auto;
    font-size: ${14 / 16}rem;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${15 / 16}rem;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    font-size: ${16 / 16}rem;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
    font-size: ${17 / 16}rem;
  }
`;

export const ScrollButton = styled.button`
  width: ${40 / 16}rem;
  height: ${40 / 16}rem;
  background-color: hsl(0, 0%, 100%);
  opacity: 0.9;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  position: absolute;
  border-radius: 50%;
  top: 120px;
  z-index: 1;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  &.right {
    right: ${12 / 16}rem;
  }

  &.left {
    left: ${12 / 16}rem;
  }
  
  &:hover {
    opacity: 1;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: scale(1.05);
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: none;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
    width: ${44 / 16}rem;
    height: ${44 / 16}rem;
    top: 130px;
  }
`;

export const NewcomersPropertiesWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  overflow-x: auto;
  gap: 12px;
  padding: 0 16px 16px;
  
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  scrollbar-width: none;
  
  &::-webkit-scrollbar {
    display: none;
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    > div {
      width: 300px;
      min-width: 300px;
      max-width: 300px;
      flex: 0 0 300px;
      margin: 0 6px;
    }
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    > div {
      width: 280px;
      min-width: 280px;
      max-width: 280px;
      flex: 0 0 280px;
      margin: 0 6px;
    }
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) and (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    padding: 0 20px 16px;
    gap: 16px;
    scrollbar-width: thin;
    
    > div {
      width: calc(33.333% - 11px);
      min-width: calc(33.333% - 11px);
      max-width: calc(33.333% - 11px);
      flex: 0 0 calc(33.333% - 11px);
      margin: 0;
    }
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) and (max-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    padding: 0 24px 20px;
    gap: 20px;
    
    > div {
      width: calc(25% - 15px);
      min-width: calc(25% - 15px);
      max-width: calc(25% - 15px);
      flex: 0 0 calc(25% - 15px);
      margin: 0;
    }
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) and (max-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
    padding: 0 32px 24px;
    gap: 20px;
    
    > div {
      width: calc(25% - 15px);
      min-width: calc(25% - 15px);
      max-width: calc(25% - 15px);
      flex: 0 0 calc(25% - 15px);
      margin: 0;
    }
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
    padding: 0 40px 28px;
    gap: 24px;
    
    flex-wrap: nowrap;
    overflow-x: auto;
    
    > div {
      width: 320px;
      min-width: 320px;
      max-width: 320px;
      flex: 0 0 320px;
      margin: 0;
    }
  }
`;

export const NewcomersPropertiesDots = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 16px;
  padding: 0 16px;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: none;
  }
`;

export const Dot = styled.div`
  width: ${10 / 16}rem;
  height: ${10 / 16}rem;
  background-color: hsla(0, 0%, 85%, 1);
  opacity: 0.45;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;

  &.active {
    opacity: 1;
    background-color: ${({ theme }) => theme.palette.secondary.orange500};
    transform: scale(1.2);
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: ${12 / 16}rem;
    height: ${12 / 16}rem;
  }
`;